var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    fill: "#D40511",
    stroke: "#D40511",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 5.12
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#D40511;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.736,165.752c-8.792-8.8-23.054-8.784-31.854,0l-13.571,13.587l46.367,46.359l13.578-13.57 c8.784-8.801,8.784-23.071,0-31.872L331.736,165.752z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.84,0,0,114.831,0,256C0,397.152,114.84,512,256,512c141.168,0,256-114.848,256-256 C512,114.831,397.168,0,256,0z M256,466.051c-115.998,0-210.051-94.053-210.051-210.051C45.949,140.002,140.002,45.94,256,45.94 c115.998,0,210.051,94.062,210.051,210.059C466.051,371.998,371.998,466.051,256,466.051z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "159.164,306.485 159.164,352.845 205.531,352.845 311.352,247.022 264.993,200.664 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPencil);
export default __webpack_public_path__ + "static/media/red_pencil.f05cf7d30553ccbb1ab0516efab24478.svg";
export { ForwardRef as ReactComponent };